import React from 'react';
import { styled } from '@ff/ui';
import Box from '@ff/ui/Box';
import { VehicleSpec } from 'client/hooks/queries/useVehicleModels';
import { colors, H3, P12 } from 'client/v3/typography';
import useVehicleModelDetails from 'client/hooks/queries/useVehicleModelDetails';

type ModelSpecsProps = {
  modelId?: number;
  specs?: VehicleSpec[];
}

export default function ModelSpecs(props: ModelSpecsProps) {
  const { modelId, specs=[] } = props
  const { vehicleModelDetails, loading: loadingVehicleModelDetails } =
    useVehicleModelDetails(modelId as number, {
      skip: !modelId || specs.length > 0 
    });

  if(loadingVehicleModelDetails){
    return null; // we don't need to show loader icon in specs
  }
    
  if (specs.length === 0) {
    if (vehicleModelDetails) {
      vehicleModelDetails.vehicleOverviewAssets.overviewSpecs.forEach(spec => {
        specs.push(spec);
      });
    }else{
      return null;
    }
  }

  return (
    <Container>
      {specs.map(spec => (
        <Spec key={spec.title}>
          <Title>{spec.title}</Title>
          <Description>{spec.description}</Description>
        </Spec>
      ))}
    </Container>
  );
}

const Container = styled(Box)({
  width: '100%',
  display: 'flex',
  justifyContent: 'space-between',
});

const Spec = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  borderRight: '1px solid #CCCCCC',
  textAlign: 'center',
  flex: 1,
  ':last-child': {
    borderRight: '0px',
  }
});

const Title = styled(H3)({
  color: '#171A20',
  lineHeight: '28px',
  fontWeight: 300,
});

const Description = styled(P12)({
  color: colors.content4,
  lineHeight: '21px',
});